"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoNodesToQueryException = void 0;
class NoNodesToQueryException extends Error {
    static CODE = 'NO_NODES_TO_QUERY';
    static MESSAGE = 'No nodes to query. Probably need to call bootstrap()';
    constructor() {
        super(NoNodesToQueryException.MESSAGE);
        this.name = NoNodesToQueryException.CODE;
    }
}
exports.NoNodesToQueryException = NoNodesToQueryException;
